import styled from '@emotion/styled';

/**
 * Visually hidden, used for screen reader only
 */
export const HiddenElementA11y = styled.span`
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;
